import {isEmpty} from '../../../utils/common'

export function dataToSupplierMappingsList(data: any[]) {
  if (isEmpty(data)) return []

  return data?.map((item: any) => ({
    productName: item['product_name'] || '-',
    brands: item?.['brand_name'] || '-',
    sku: item?.['sku'] || '-',
    productId: item?.['product_id'] || '-',
  }))
}
